// node websocket module
// var WebSocket = require('ws');
// proto定义和接口
var proto = require('./msg_service_pb');
// 发包解包工具
import pack from './pack';



const MSG_WS_CMD_HEART_BEAT = 1;    // 心跳处理
const MSG_WS_CMD_COMM_MSG = 2;      // 通用消息收发
const MSG_WS_CMD_BIND = 3;          // 绑定信息
const MSG_WS_CMD_AUTH_KEY = 4;      // key 方式 鉴权


// ----------- File 4 client lib ----------- 
var MsgWsClient = {
    ws : null,
    hasInit : false,
    hbIntervalId : 0,
    sendWaitQueue : new Array(),

    conf : {
        proto: "ws",
        host : "",
        port : "",
        path : "",
        authSys : "",
        authKey : "",
        toBindMap : new Map(),
        onOpen : null,
        onMessage : null,
        onClose : null,
        onError : null,
        onSendSuccess : null,
        onSendFail : null,
        bzMsgDealerMap : new Map(),
        debug : false,
    },

    init : function(confData){
        this.conf = Object.assign(this.conf, confData);
        this.hasInit = true;
    },

    startRun : function(){
        if (!this.hasInit){
            console.log("not init error");
            return;
        }
        let connAddr = this.conf.proto + "://" + this.conf.host +":" + this.conf.port + this.conf.path;
        console.log("wsaddr:" + connAddr);
        this.ws = new WebSocket(connAddr);

        let that = this;

        this.ws.onopen = function(){
            that.ws.binaryType = 'arraybuffer'; // must

            if (that.conf.onOpen) {
                that.conf.onOpen();
            }

            // send auth
            that.sendAuth();
            // send all bind
            that.sendBinds();

            // send waiting queue
            if (that.sendWaitQueue.length > 0) {
                // just wait auth and binds...
                setTimeout(function(){
                    let copyWaitQueue = that.sendWaitQueue.slice();
                    that.sendWaitQueue = new Array();
                    for (let i = 0; i < copyWaitQueue.length; i++) {
                        that.sendBytes(copyWaitQueue[i]);
                    }
                }, 1000);
            }
            
            //start heart beat
            if (that.hbIntervalId) {
                clearInterval(that.hbIntervalId);
            }
            that.hbIntervalId = setInterval(function(){that.sendHeartBeat()}, 5000);
            console.log("ws has closed, wait for reconnect...");

        };

        this.ws.onmessage = function(evt) {
            if (that.conf.onMessage){
                that.conf.onMessage();
            }
            let packet = pack.MsgSvrPacker.unpack(evt.data);
            if (packet.H_Cmd == MSG_WS_CMD_COMM_MSG && packet.H_Version == 1){
                let msg = proto.Msg.deserializeBinary(packet.PayloadBody);
                if (that.conf.bzMsgDealerMap && that.conf.bzMsgDealerMap.has(msg.getBzid())){
                    that.conf.bzMsgDealerMap.get(msg.getBzid()) (msg);
                }
            }
        };

        this.ws.onclose = function(){
            if (that.conf.onClose) {
                that.conf.onClose();
            }
            setTimeout(function(){that.startRun();}, 2000);
            
        };

        this.ws.onerror=function(event){
            console.log("WS connect Error");
            if (that.conf.onError) {
                that.conf.onError();
            }
        }
    },

    sendBytes : function(uint8ArrBuf, needSaveFail = false){
        if (this.ws.readyState == WebSocket.OPEN) {
            this.ws.send(uint8ArrBuf);
            if (this.conf.onSendSuccess) {
                this.conf.onSendSuccess();
            }

        } else {
            if (needSaveFail) {
                this.sendWaitQueue.push(uint8ArrBuf);
            }else{
                console.log(this.ws.readyState)
                console.log("send fail.ws state not open");
            }
            
            if (this.conf.onSendFail) {
                this.conf.onSendFail();
            }
        }
    },

    sendAuth : function(key){
        let authKey = key;
        if (!authKey){
            authKey = this.conf.authKey;
        }
        if (!authKey){
            return;
        }
        let authKeyReq = new proto.AuthKeyReq();
        authKeyReq.setKey(authKey);
        this.sendBytes(pack.MsgSvrPacker.pack(1, MSG_WS_CMD_AUTH_KEY, authKeyReq.serializeBinary()));
    },

    sendBinds : function(bindMap){
        let toBind = bindMap;
        if (!toBind || toBind.length == 0){
            toBind = this.conf.toBindMap;
        }
        if (!toBind || toBind.length == 0){
            return;
        }
        
        // 处理所有的绑定请求
        for (let bzIdKey of toBind.keys()) {
            // 补充bind
            if (!this.conf.toBindMap.has(bzIdKey)){
                this.conf.toBindMap.set(bzIdKey, snAtGroup);
            }

            let bindEndPoint = this.makeFromEndPointByBindKey(bzIdKey);
            if (!bindEndPoint) {
                continue;
            }

            let bindReq = new proto.BindReq();
            bindReq.setTobindbzid(bzIdKey);
            bindReq.setOp("bind");
            bindReq.setBindendpoint(bindEndPoint);
            //console.log(bindReq.serializeBinary());
            this.sendBytes(pack.MsgSvrPacker.pack(1, MSG_WS_CMD_BIND, bindReq.serializeBinary()));
        }
    },

    sendHeartBeat : function(){
        let hbReq = this.sendBytes(pack.MsgSvrPacker.pack(1, MSG_WS_CMD_HEART_BEAT, null));
    },

    sendMsg : function(bzId, op, bzDataStr, sendToStr) {
        if (!bzId || !op) {
            return;
        }

        // get group and sn to make endpoint
        let endPointFrom = this.makeFromEndPointByBindKey(bzId);
        let msg = new proto.Msg();
        msg.setBzid(bzId);
        msg.setOp(op);
        if (endPointFrom) {
            msg.setFrom(endPointFrom);
        }
        if (bzDataStr) {
            msg.setBzdata(bzDataStr);
        }
        if (sendToStr) {
            let toEndPoint = this.getEndPointObjByStr(sendToStr);
            if (toEndPoint) {
                msg.setTo(toEndPoint);
            }
        }
        this.sendBytes(pack.MsgSvrPacker.pack(1, MSG_WS_CMD_COMM_MSG, msg.serializeBinary()), true);
    },

    getEndPointObjByStr : function(str) {
        let rows = str.split("@");
        if (rows.length != 2 || !rows[0] || !rows[1]) {
            return null;
        }

        let endPoint = new proto.MsgEndPoint();
        endPoint.setGroup(rows[1]);
        endPoint.setSn(rows[0]);

        return endPoint;
    },

    makeFromEndPointByBindKey : function(bzId){
        if (!this.conf.toBindMap.has(bzId)){
            return null;
        }

        let snAtGroup = this.conf.toBindMap.get(bzId);
        return this.getEndPointObjByStr(snAtGroup);
    },
}

// module.exports.MsgWsClient = MsgWsClient;
export default {
    MsgWsClient : MsgWsClient   
}



// WEBPACK FOOTER //
// ./src/vendor/qnbar/msgWsClient.js